import {
  IS_ADMIN_USER,
  LINKS_SURVEY_ADMIN_ENTRY,
  LINKS_SURVEY_ENTRY,
  ROLES,
  SHOW_HINT,
  SMALL_HEADER_EXPANDED,
  toggleSmallHeaderAction
} from "../../../ducks/login";
import {
  ALL_INDICATORS,
  EDITING_PAGE_DESCRIPTION,
  EDITING_PAGE_KEY,
  EDITING_PAGE_TITLE,
  EDITING_PAGE_VISIBILITY,
  PREDEFINED_LIST,
  PREDEFINED_LIST_TYPE,
  resetSurvey as resetSurveyEditor,
  SHOW_MODAL_PAGE_EDITOR
} from "../../../ducks/surveyEditor";
import {
  changeEditState,
  EDIT_SURVEY_HEADER,
  hidePreviewSurvey,
  hideQuestionSyncDialog,
  onConfirm,
  previewSurvey,
  propertyChange,
  QUESTION_SYNC,
  resetSurvey,
  saveAndSyncSurveyQuestions,
  saveSurvey,
  SHOW_SURVEY_PREVIEW,
  showQuestionSyncDialog,
  SURVEY_DESCRIPTION_DRAFT,
  SURVEY_IDENTIFIER,
  SURVEY_LANGUAGE,
  SURVEY_NAME,
  SURVEY_NAME_DRAFT,
  SURVEY_TEMPLATE,
  SURVEY_VERSION,
  SYNC_DIALOG_OPEN
} from "../../../ducks/survey";
import {
  getQuestionLibraryFromOverview,
  QUESTION_LIBRARY,
  showModalForSavingQuestionToLibrary,
  showModalForSavingQuestionToMyLibrary
} from "../../../ducks/questionLibrary";
import {
  addIndicatorToQuestion,
  addPage,
  addQuestion,
  addQuestionChoice,
  cancelSubchoice,
  changeQuestionField,
  changeSelectedPage,
  clearAllMessages,
  confirmSubchoice,
  copyQuestion,
  editPage,
  editSubchoice,
  filterInvisible,
  loadIndicators,
  loadIndicatorsSuccessful,
  loadPredefinedList,
  loadSuccessful,
  moveQuestionToPage,
  prepareDataForPageEditing,
  propertyChange as editorPropertyChange,
  removeIndicatorFromQuestion,
  removePage,
  removeQuestion,
  removeQuestionChoice,
  reorderChoice,
  reorderPage,
  reorderQuestion,
  setTriggers,
  setValidator,
  setValidatorProperty
} from "../../../ducks/surveyEditorActions";

import { LANGUAGE } from "../../../ducks/languageSelector";
import { PAGES_KEY, QUESTION_LIBRARY_STORE } from "../../../common/constant";
import SurveyEditor from "./SurveyEditor";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { doLogout } from "../../../ducks/logout";
import { loadAllData } from "../../../ducks/indicatorManagament";
import { showDialog } from "../../../ducks/confirmDialog";

/**
 * Container serves two purposes:
 * Binding of specified initial state elements to initial properties of SurveyEditor.js.
 * Binding of specified properties of SurveyEditor.js and its children to actions being handled in surveyEditor.js.
 */
const mapStateToProps = (state) => {
  return {
    pages: state.surveyEditor.pages,
    selectedPage: state.surveyEditor.selectedPage,
    invisible: state.surveyEditor.invisible,
    identifier: state.survey[SURVEY_IDENTIFIER],
    version: state.survey[SURVEY_VERSION],
    questionSync: state.survey[QUESTION_SYNC],
    surveyName: state.survey[SURVEY_NAME],
    surveyDescription: state.survey[SURVEY_DESCRIPTION_DRAFT],
    surveyTemplate: state.survey[SURVEY_TEMPLATE],
    showSurveyPreview: state.survey[SHOW_SURVEY_PREVIEW],
    syncDialogOpen: state.survey[SYNC_DIALOG_OPEN],
    link: state.login[LINKS_SURVEY_ENTRY],
    surveyAdminLink: state.login[LINKS_SURVEY_ADMIN_ENTRY],
    editorPages: state.surveyEditor[PAGES_KEY],
    editSurveyHeader: state.survey[EDIT_SURVEY_HEADER],
    surveyDescriptionDraft: state.survey[SURVEY_DESCRIPTION_DRAFT],
    surveyNameDraft: state.survey[SURVEY_NAME_DRAFT],
    smallHeaderExpanded: state.login[SMALL_HEADER_EXPANDED],
    predefinedList: state.surveyEditor[PREDEFINED_LIST],
    predefinedListType: state.surveyEditor[PREDEFINED_LIST_TYPE],
    language: state.languageSelector[LANGUAGE],
    allIndicators: state.surveyEditor[ALL_INDICATORS],
    showModalPageEditor: state.surveyEditor[SHOW_MODAL_PAGE_EDITOR],
    editingPageTitle: state.surveyEditor[EDITING_PAGE_TITLE],
    editingPageKey: state.surveyEditor[EDITING_PAGE_KEY],
    editingPageDescription: state.surveyEditor[EDITING_PAGE_DESCRIPTION],
    editingPageVisibility: state.surveyEditor[EDITING_PAGE_VISIBILITY],
    surveyLanguage: state.survey[SURVEY_LANGUAGE],
    role: state.login[ROLES],
    isAdminUser: state.login[IS_ADMIN_USER],
    showHint: state.login[SHOW_HINT],
    questionLibrary: state[QUESTION_LIBRARY_STORE][QUESTION_LIBRARY]
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      addQuestion,
      removeQuestion,
      addPage,
      editPage,
      removePage,
      changeQuestionField,
      addQuestionChoice,
      removeQuestionChoice,
      editSubchoice,
      confirmSubchoice,
      cancelSubchoice,
      changeSelectedPage,
      reorderQuestion,
      reorderChoice,
      reorderPage,
      setValidator,
      setValidatorProperty,
      filterInvisible,
      setTriggers,
      showDialog,
      propertyChange,
      saveSurvey,
      resetSurvey,
      resetSurveyEditor,
      previewSurvey,
      hidePreviewSurvey,
      showQuestionSyncDialog,
      hideQuestionSyncDialog,
      saveAndSyncSurveyQuestions,
      changeEditState,
      onConfirm,
      toggleSmallHeaderAction,
      loadPredefinedList,
      loadSuccessful,
      loadIndicators,
      clearAllMessages,
      loadIndicatorsSuccessful,
      addIndicatorToQuestion,
      removeIndicatorFromQuestion,
      copyQuestion,
      doLogout,
      moveQuestionToPage,
      editorPropertyChange,
      prepareDataForPageEditing,
      showModalForSavingQuestionToLibrary,
      showModalForSavingQuestionToMyLibrary,
      loadAllData,
      getQuestionLibraryFromOverview
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(SurveyEditor);
